export default {
  methods: {
    filterByTournament(match) {
      return this.selectedTournament
        ? match.idTournament === this.selectedTournament.id : true;
    },
    filterBySport(match) {
      return this.selectedSport
        ? match.idSport === this.selectedSport.id : true;
    },
    tournamentSelected(tournament) {
      this.selectedTournament = tournament;
      this.scrollToTop();
    },
    scrollToTop() {
      this.$nextTick(() => {
        if (this.$refs.matchesWrapper) {
          this.$refs.matchesWrapper.scrollTop = 0;
        }
      });
    },
  },
};
